module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.response && _vm.validUrl) ? _c('div', {
    style: ({
      width: _vm.cardWidth
    }),
    attrs: {
      "id": "loader-container"
    }
  }, [_vm._t("loading", [_c('div', {
    staticClass: "spinner"
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.response) ? _c('div', [_vm._t("default", [_c('div', {
    staticClass: "wrapper",
    style: ({
      width: _vm.cardWidth
    })
  }, [_c('div', {
    staticClass: "card-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.response.images[0]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-info"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.response.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.response.description))])]), _vm._v(" "), _c('div', {
    staticClass: "card-btn"
  }, [(_vm.showButton) ? _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.viewMore
    }
  }, [_vm._v("View More")]) : _vm._e()])])])], {
    img: _vm.response.images[0],
    title: _vm.response.title,
    description: _vm.response.description,
    url: _vm.url
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b901162","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/LinkPrevue.vue
// module id = 6
// module chunks = 0